// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".richTextSummaryDetail-module_root_uOHktmVITXgrgNEFOyqr{margin:16px 0}", "",{"version":3,"sources":["webpack://./src/bloks/richTextWidgets/richTextSummaryDetail/richTextSummaryDetail.module.scss"],"names":[],"mappings":"AACA,wDACI,aAAA","sourcesContent":["@import \"src/styles/theme.scss\";@import \"~@crunchyroll/cx-web-themes/crunchyroll/abstracts/main\";\n.root {\n    margin: 16px 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "richTextSummaryDetail-module_root_uOHktmVITXgrgNEFOyqr"
};
export default ___CSS_LOADER_EXPORT___;
